import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id E13ACA71-A398-4E3F-A1DF-ED7E4A1E1A84
 * name layers-triple
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/layers-triple.svg
 * tags
 */
export const LayersTripleIcon = createSvgIcon(<><path d="M12 0L3 7L4.63 8.27L12 14L19.36 8.27L21 7L12 0M19.37 10.73L12 16.47L4.62 10.74L3 12L12 19L21 12L19.37 10.73M19.37 15.73L12 21.47L4.62 15.74L3 17L12 24L21 17L19.37 15.73Z" /></>, 'LayersTripleIcon');
export default LayersTripleIcon